
// components/QtyInput.js  
// import React, { useEffect, useState } from 'react';
// import { TextField } from '@mui/material';

// const QtyInput = ({ i, index, value, setFieldValue, name, error, helperText, disabled, theme, handleBlur }) => {
//   const [localQty, setLocalQty] = useState(value || '');

//   // Sync local state with Formik when external value changes
//   useEffect(() => {
//     setLocalQty(value || '');
//   }, [value]);

//   return (
//     <TextField
//       disabled={disabled}
//       margin="dense"
//       variant="filled"
//       fullWidth
//       value={localQty}
//       name={name}
//       onChange={(e) => {
//         setLocalQty(e.target.value);
//       }}
//       onBlur={(e) => {
//         setFieldValue(name, localQty); // Sync back to Formik on blur
//         handleBlur(e); // Also trigger Formik's internal blur logic
//       }}
//       error={error}
//       helperText={helperText}
//       InputLabelProps={{
//         shrink: true,
//         style: {
//           color: theme.palette.text.primary,
//         },
//       }}
//       sx={{
//         width: {
//           xs: '100px',
//           sm: '100px',
//           md: '100px',
//         },
//         height: '40px',
//         '& .MuiInputBase-root': {
//           fontSize: '0.8rem',
//           height: '40px',
//         },
//         '& .MuiInputBase-input': {
//           padding: '0 12px',
//           height: '40px',
//           lineHeight: '40px',
//         },
//       }}
//     />
//   );
// };

// export default React.memo(QtyInput);

import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';

const QtyInput = ({
  i,
  index,
  value,
  name,
  theme,
  disabled,
  error,
  helperText,
  setFieldValue,
  handleBlur,
  isSubmitting, // Add this if you want to sync on submit
}) => {
  const [localQty, setLocalQty] = useState(value || '');

  useEffect(() => {
    setLocalQty(value || '');
  }, [value]);

  useEffect(() => {
    if (isSubmitting) {
      setFieldValue(name, localQty); // Sync on submit
    }
  }, [isSubmitting]);

  const handleChange = (e) => {
    setLocalQty(e.target.value);
    // ✅ Do NOT call setFieldValue here — keeps focus intact
  };

  const handleBlurInternal = (e) => {
    setFieldValue(name, localQty); // Sync with Formik
    handleBlur(e); // Mark field as touched
  };

  return (
    <TextField
      disabled={disabled}
      margin="dense"
      variant="filled"
      fullWidth
      value={localQty}
      name={name}
      onChange={handleChange}
      onBlur={handleBlurInternal}
      error={error}
      helperText={helperText}
      InputLabelProps={{
        shrink: true,
        style: {
          color: theme.palette.text.primary,
        },
      }}
      sx={{
        width: {
          xs: '100px',
          sm: '100px',
          md: '100px',
        },
        height: '40px',
        '& .MuiInputBase-root': {
          fontSize: '0.8rem',
          height: '40px',
        },
        '& .MuiInputBase-input': {
          padding: '0 12px',
          height: '40px',
          lineHeight: '40px',
        },
      }}
    />
  );
};

export default React.memo(QtyInput);


// components/QtyInput.js
// import React, { useEffect, useState } from 'react';
// import { TextField } from '@mui/material';

// const QtyInput = ({
//   i,
//   index,
//   value,
//   name,
//   theme,
//   disabled,
//   error,
//   helperText,
//   setFieldValue,
//   setDispatchDetails,
//   values,
//   handleBlur,
// }) => {
//   const [localQty, setLocalQty] = useState(value || '');

//   // Sync localQty when formik value updates externally
//   useEffect(() => {
//     setLocalQty(value || '');
//   }, [value]);

//   const handleQtyChange = (e) => {
//     const newQty = e.target.value;
//     setLocalQty(newQty);

//     // Update local UI state (dispatch details)
//     const updatedDetails = values?.ProcessData[i]?.DispatchDetails.map((d, idx) => {
//       if (idx === index) {
//         return { ...d, DispatchQty: newQty };
//       }
//       return { ...d };
//     });

//     setDispatchDetails((prevDetails) => {
//       const newDetails = [...prevDetails];
//       newDetails[i] = updatedDetails;
//       return newDetails;
//     });

//     // Don't update Formik here — wait for onBlur
//   };

//   const handleQtyBlur = (e) => {
//     handleBlur(e); // Formik's blur logic
//     setFieldValue(name, localQty); // Update Formik on blur
//   };

//   return (
//     <TextField
//       disabled={disabled}
//       margin="dense"
//       variant="filled"
//       fullWidth
//       value={localQty}
//       name={name}
//       onChange={handleQtyChange}
//       onBlur={handleQtyBlur}
//       error={error}
//       helperText={helperText}
//       InputLabelProps={{
//         shrink: true,
//         style: { color: theme.palette.text.primary },
//       }}
//       sx={{
//         width: { xs: '100px', sm: '100px', md: '100px' },
//         height: '40px',
//         '& .MuiInputBase-root': {
//           fontSize: '0.8rem',
//           height: '40px',
//         },
//         '& .MuiInputBase-input': {
//           padding: '0 12px',
//           height: '40px',
//           lineHeight: '40px',
//         },
//       }}
//     />
//   );
// };

// export default React.memo(QtyInput);

